import { HeaderProps, Header } from "@Light/components/page/header/Header";
import React from "react";

export const PortalHeader: React.FC<HeaderProps> = React.forwardRef(
  (props, ref) => {
    return (
      <Header ref={ref} {...props} titleLink={undefined} rightButton={<></>} />
    );
  },
);
